
// Currency switcher


function initCurrencySwitcher() {
  const switchers = Array.from(document.querySelectorAll('.currency-select'))
  switchers.forEach(s => {
    let options = Array.from(s.querySelectorAll('.currency-list li a'))
    // Skip the back button
    options = options.filter(o => o.classList.contains('currency-close-btn') === false);
    options.forEach(option => {
      // console.log(option)
      option.addEventListener('click', (e) => {
        // If you're going to the same subdomain (the origins match) and just changing currency
        if (option.href.indexOf(window.location.origin) !== -1) {
          const currency = option.parentElement.getAttribute('data-value');
          e.preventDefault();
          const data = {
            currency: currency
          }
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then(response => response.json())
          .then(data => {
            if (data.currency === currency) {
              // successfully changed
              window.location.reload();
            } else {
              console.log(`${currency} not supported on this site`);
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        } else {
          // If you're going to a new subdomain
          console.log('Redirecting')
          // The switcher has an actual link
          e.preventDefault();
          // Redirect the user with their cart and wishlist
          redirectToRegional(option.href)
        }
      })
    })
  })
}
initCurrencySwitcher();





// Mobile currency open
$('#main-nav').on('click', '.currency-btn', function() {
  $('#main-nav > ul, #mobile-search').toggleClass('slide-out');
});
// Mobile currency close
$('#main-nav').on('click', '.currency-close-btn', function() {
  $('#main-nav > ul, #mobile-search').toggleClass('slide-out');
});
